import { SalesDespatchItemProcessingReport } from './sales-despatch-item-processing-report';

export interface SalesDespatchItemReport {
  packNo: string;
  stockNo: string;
  supplierStockNo: string;
  productKey: string;
  productDescription: string;
  makeUp: string;
  customerProduct: string;
  customerLineRef: string;
  grossQuantity: number;
  nettQuantity: number;
  noOfItems: number;
  unitOfMeasure: string;
  returnMessage: string;

  salesDespatchItemProcessings: SalesDespatchItemProcessingReport[];
}
